import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter, ProductExpandTokens } from "@insite/client-framework/Services/ProductServiceV2";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import { chain, DisplayProductsResult, SetExpandTokens } from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
    relevancy?: boolean;
}

interface Props {
    apiParameter: GetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;
export const SetExpandTokensExtended: HandlerType = props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "badges", "content"];

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
};

replaceInChain(chain, SetExpandTokens, SetExpandTokensExtended);
